<script setup lang="ts">
import { T } from '@tolgee/vue'
import DefaultDiscountBadge from '@/components/periodic/default-discount/DefaultDiscountBadge.vue'
import { useShop } from '@/composables/game/shop'
import { useSkin } from '@/composables/game/skin'
import { computed } from 'vue'
import { formatDuration } from '@/helpers/date'
import IWDBadge from '@/components/periodic/IWD/IWDBadge.vue'
import STPBadge from '@/components/periodic/STP/STPBadge.vue'

const { isDefaultDiscount, countdownForSaleEnds, isSale, isIWD, isSTP, isBOGO, isBOGX } = useShop()
const { canHaveSale } = useSkin()

const hasSale = computed(() => canHaveSale.value && isSale.value && !isBOGO.value && !isBOGX)

</script>

<template>
  <div class="relative size-[48px] bg-dark-top-layer rounded-[15px] flex items-center justify-center skin-button-container pt-1.5">
    <div
      v-if="hasSale"
      class="absolute -left-4 -top-4 w-[44px] h-auto z-[3]"
    >
      <DefaultDiscountBadge
        v-if="isDefaultDiscount"
      />
      <IWDBadge v-if="isIWD" />
      <STPBadge v-else-if="isSTP" />
    </div>

    <div class="flex items-center justify-center h-full w-full overflow-hidden rounded-[15px] mt-0.5">
      <img
        class="h-full w-auto object-cover z-[1]"
        src="@/assets/images/gifs/duck-money-eye.gif"
      >
    </div>

    <div class="absolute left-1/2 -translate-x-1/2 h-[18px] px-1.5 top-[38px] rounded-full bg-white flex items-center justify-center text-[10px] font-bold leading-[14px] -tracking-[0.3px] text-dark-top-most-layer z-[4] whitespace-nowrap">
      <span
        v-if="hasSale"
        :class="countdownForSaleEnds < (3600 * 12) && 'text-red-accent'"
      >
        {{ formatDuration(countdownForSaleEnds, undefined, countdownForSaleEnds > (3600 * 72)) }}
      </span>
      <span v-else>
        <T
          key-name="tap.skins"
          default-value="Skins"
        />
      </span>
    </div>
  </div>
</template>
<style scoped>
.skin-button-container::before {
	content: '';
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	border: 2.5px solid rgba(255, 255, 255, 0.4); /* Semi-transparent border */
	pointer-events: none; /* Ensure it doesn't interfere with interaction */
	z-index: 2; /* Place the border above the content */
	border-radius: 15px;
}
</style>
